/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const base = require('base/components/clientSideValidation');

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    let valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this)
            .find('input, select, textarea')
            .each(() => {
                if (!this.validity.valid) {
                    $(this).trigger('invalid', this.validity);
                }
            });
    }
    return valid;
}

module.exports = {
    invalid() {
        $('form input, form select, form textarea').on('invalid', (e) => {
            e.preventDefault();
            const thisTarget = e.target;
            thisTarget.setCustomValidity('');
            if (!thisTarget.validity.valid) {
                if ($(thisTarget).data('general-error')) {
                    thisTarget.setCustomValidity($(thisTarget).data('general-error'));
                }
                let { validationMessage } = thisTarget;
                $(thisTarget).addClass('is-invalid');
                if (thisTarget.validity.patternMismatch && $(thisTarget).data('pattern-mismatch')) {
                    validationMessage = $(thisTarget).data('pattern-mismatch');
                }
                if (
                    (thisTarget.validity.rangeOverflow || thisTarget.validity.rangeUnderflow)
                    && $(thisTarget).data('range-error')
                ) {
                    validationMessage = $(thisTarget).data('range-error');
                }
                if (
                    (thisTarget.validity.tooLong || thisTarget.validity.tooShort)
                    && $(thisTarget).data('range-error')
                ) {
                    validationMessage = $(thisTarget).data('range-error');
                }
                if (thisTarget.validity.valueMissing && $(thisTarget).data('missing-error')) {
                    validationMessage = $(thisTarget).data('missing-error');
                }

                $(thisTarget)
                    .parents('.form-group')
                    .find('.invalid-feedback')
                    .text(validationMessage);

                $(thisTarget)
                    .attr('title', validationMessage);
            }
        });
    },
    submit: base.submit,
    buttonClick: base.buttonClick,
    functions: {
        validateForm(form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: base.clearForm,
    },
};
